import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
// import { compact } from 'lodash'
import config from '../../../../config';
import request from '../../../../helpers/request';
import { CodeInput } from '../../../../components/inputs';
import { SquareButton } from '../../../../components/buttons';
import SvgIcon from '../../../../components/svgIcon';
import styles from './paySafelyInvoice.css';

import InvoizSvg from '../../../../assets/images/invoiz.svg';
import InvoicePng from '../../../../assets/images/invoice.png';

const DEFAULT_HINT = { type: 'info', text: '' };
const PAGE_TITLE = 'sicher-zahlen.de';
const TEXT_ERROR_EMPTY = 'Es müssen alle Felder gefüllt sein';
const TEXT_ERROR_INVALID = 'Der eingegebene Code ist ungültig';
const CODE_LENGTH = 6;
const INVOICE_PNG_ALT_TEXT = 'Rechnung';

const location = window.location;

export default class PaySafelyInvoice extends React.Component {
  constructor(props) {
    super(props);
    const {
      match: {
        params: { token }
      }
    } = props;
    const shortenedCode = token && token.length ? token.substr(0, CODE_LENGTH) : PaySafelyInvoice.defaultProps.code;
    this.state = {
      hint: DEFAULT_HINT,
      code: shortenedCode,
      isValid: false
    };
    this.codeInput = undefined;
    this.handleCodeChange = this.handleCodeChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onShowInvoiceError = this.onShowInvoiceError.bind(this);
    this.onShowInvoiceSuccess = this.onShowInvoiceSuccess.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentWillMount() {
    this.validate();
  }

  componentDidMount() {
    if (this.codeInput) {
      this.codeInput.focus();
    }

    if (this.state.code.length >= CODE_LENGTH) {
      this.showInvoiceWithCode();
    }
  }

  showInvoiceWithCode = () => {
    const { code } = this.state;
    const path = `${config.assetResourceHost}/external/code/${code}`;
    return request(path)
      .then(this.onShowInvoiceSuccess)
      .catch(this.onShowInvoiceError);
  };

  onShowInvoiceError(error) {
    this.codeInput.focus();
    if (error.statusCode === 404) {
      this.setState({ hint: { type: 'error', text: TEXT_ERROR_INVALID } });
    }
    return error;
  }
  onShowInvoiceSuccess({ body: { data } }) {
    const { invoiceDocumentId, token } = data;
    // redirect to customer-center invoice
    location.href = `${config.customerCenterHost}/external/invoice/document/${invoiceDocumentId}/${token}`;
  }

  validate(cb) {
    const { code } = this.state;

    if (code.length < CODE_LENGTH) {
      return this.setState({ isValid: false });
    }

    return this.setState({ isValid: true }, cb);
  }

  handleCodeChange(code) {
    const { code: actualCode } = this.state;
    if (actualCode === code) return;

    const state = { code };
    if (code.length <= CODE_LENGTH) {
      state.hint = DEFAULT_HINT;
    }
    this.setState(state, function() {
      this.validate();
    });
  }

  handleSubmit({ nativeEvent: event }) {
    event.preventDefault();

    const handleSubmitValidationCallback = function handleSubmitValidationCallback() {
      const { isValid } = this.state;

      if (!isValid) {
        return this.setState({ hint: { type: 'error', text: TEXT_ERROR_EMPTY } });
      }
      this.showInvoiceWithCode();
    }.bind(this);

    this.validate(handleSubmitValidationCallback);
  }

  render() {
    const { code, hint, isValid } = this.state;

    return (
      <div className={styles.content}>
        <Helmet defaultTitle="" titleTemplate="">
          <title>{PAGE_TITLE}</title>
        </Helmet>
        <div className={styles.left}>
          <form className={styles.form} onSubmit={this.handleSubmit} ref="form">
            <h1 className={styles.heading}>Geben Sie hier den Zugriffs-Code Ihrer Rechnung ein</h1>
            <CodeInput
              className={styles.codeInput}
              length={CODE_LENGTH}
              code={code.split('')}
              hint={hint}
              ref={input => {
                this.codeInput = input;
              }}
              name="code"
              onChange={this.handleCodeChange}
            />
            <SquareButton label="Rechnung anzeigen" format="full" disabled={!isValid} type="submit" />
            <div className={styles.footer}>
              <span className={styles.poweredBy}>sicher-zahlen.de is powered by</span>
              <a className={styles.link} href="https://www.invoiz.de" alt="Rechnungen schreiben mit invoiz">
                <SvgIcon icon={InvoizSvg} className={styles.icon} />
              </a>
            </div>
            <div className={styles.imprint}>
              <a
                className={styles.link}
                href="https://www.invoiz.de/impressum/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Impressum
              </a>
              <span>|</span>
              <a
                className={styles.link}
                href="https://www.invoiz.de/agb-datenschutz/"
                rel="noopener noreferrer"
                target="_blank"
              >
                AGB & Datenschutz
              </a>
            </div>
          </form>
        </div>
        <div className={styles.right}>
          <img src={InvoicePng} alt={INVOICE_PNG_ALT_TEXT} />
        </div>
      </div>
    );
  }
}

PaySafelyInvoice.propTypes = {
  code: PropTypes.string
};

PaySafelyInvoice.defaultProps = {
  code: ''
};



// WEBPACK FOOTER //
// ./src/routes/paySafely/invoice/components/paySafelyInvoice.jsx